import { Component, Input, OnInit, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { RoEthosUserEntity } from '../../meta-data/performancemanagement-meta-data.service';
import { EmployeeReviewAnalysis, QuestionSummary } from '../../services/performance-management-review.service';

@Component({
  selector: 'app-employee-review-skills-grid',
  templateUrl: './employee-review-skills-grid.component.html',
  styleUrls: ['./employee-review-skills-grid.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EmployeeReviewSkillsGridComponent {
  @Input() employeeReviewAnalysis: EmployeeReviewAnalysis;
  @Input() employeeUser: RoEthosUserEntity;
  @Input() supervisorUser: RoEthosUserEntity;
  
  expanded : { [prop:string]:boolean } = {};

  toggleExpansion(questionSummary: QuestionSummary, expanded: boolean) {
    this.expanded[questionSummary?.question?.EmployeeReviewQuestionId] = expanded;
  }
}
